import { useEffect, useState } from 'react'
import { FreespinsPressToRunCounterEndedMessage, GameUIMessageType } from 'game-ui-types'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'
import { useConfigurationStore } from '@stores'
import { useTranslation } from '@amusnet/translations/react'
import { useMessageData } from '@hooks'
import { getZoomToFit } from '@amusnet/react-ui'

interface FreespinsPressStartCounterProps {
    duration?: number
}

const FreespinsPressStartCounter: React.FC<FreespinsPressStartCounterProps> = ({ duration = 15000 }) => {
    const { t } = useTranslation()

    const isFreespinsPressStartCounterActive = useFreeSpinsBonusesStore(
        (state) => state.isFreespinsPressStartCounterActive
    )

    const setIsFreespinsPressStartCounterActive = useFreeSpinsBonusesStore(
        (state) => state.setIsFreespinsPressStartCounterActive
    )

    const isGameLoaded = useConfigurationStore((state) => state.isGameLoaded)

    const wrapperPosition = useConfigurationStore(
        (state) => state.getComponentConfig('PressStartCounterWrapper').position
    )

    const [secondsLeft, setSecondsLeft] = useState(duration / 1000)

    const sendFreespinPressToRunCounterEndedMessage = () => {
        const msg: FreespinsPressToRunCounterEndedMessage = {
            type: GameUIMessageType.FREESPINS_PRESS_TO_RUN_COUNTER_ENDED,
        }

        window.postMessage(msg)
    }

    const completePressStartCounter = () => {
        sendFreespinPressToRunCounterEndedMessage()
        setIsFreespinsPressStartCounterActive(false)
    }

    useMessageData(({ type }) => {
        if (type === GameUIMessageType.FREESPINS_SPLASH_STARTED) {
            setIsFreespinsPressStartCounterActive(false)
        }
    }, [])

    useEffect(() => {
        if (!isFreespinsPressStartCounterActive) return

        if (secondsLeft <= 0) {
            completePressStartCounter()

            return
        }

        const timer = setTimeout(() => {
            setSecondsLeft((s) => s - 1)
        }, 1000)

        return () => clearTimeout(timer)
    }, [secondsLeft, isFreespinsPressStartCounterActive])

    return (
        isGameLoaded &&
        isFreespinsPressStartCounterActive && (
            <div
                className={`absolute pt-4 pb-4 gap-6 opacity-100 font-roboto cursor-pointer bg-[linear-gradient(90deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.5)_10%,rgba(0,0,0,0.5)_90%,rgba(0,0,0,0)_100%)]`}
                style={{
                    width: '700px',
                    height: '221px',
                    ...wrapperPosition,
                }}
                onClick={completePressStartCounter}
            >
                <div
                    className={`flex flex-col pt-4 pb-4 gap-2 font-roboto items-center justify-center text-center font-black text-[40px] leading-[100%] tracking-[0%] text-transparent bg-[linear-gradient(180deg,#FFCB32_22.37%,#FFE95D_52.1%,#D5A703_79.38%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] drop-shadow-[2px_4px_6px_rgba(0,0,0,0.5)]`}
                    style={{
                        width: '700px',
                        height: '94px',
                    }}
                >
                    <span
                        style={{
                            zoom: getZoomToFit(29, t('gameui.toRunThisFeature')),
                        }}
                    >
                        {t('gameui.press')}
                    </span>
                    <span
                        style={{
                            zoom: getZoomToFit(29, t('gameui.toRunThisFeature')),
                        }}
                    >
                        {t('gameui.toRunThisFeature')}
                    </span>
                </div>
                <div
                    className={`flex flex-col pt-4 mt-4 pb-4 gap-1 opacity-100 text-white [text-shadow:0px_4px_4px_rgba(0,0,0,0.5)]`}
                    style={{
                        width: '600px',
                        height: '71px',
                    }}
                >
                    <div
                        className={`text-center font-bold text-[24px] leading-[24px] tracking-[0.01em]`}
                        style={{
                            width: '700px',
                            height: '24px',
                        }}
                    >
                        <span
                            style={{
                                zoom: getZoomToFit(47, t('gameui.thisFeatureWillStartAutomaticallyAfter')),
                            }}
                        >
                            {t('gameui.thisFeatureWillStartAutomaticallyAfter')}
                        </span>
                    </div>
                    <div
                        className={`flex items-baseline justify-center gap-2`}
                        style={{
                            width: '700px',
                            height: '47px',
                        }}
                    >
                        <span className={`font-bold text-[40px] inline-block leading-[100%]`}>{secondsLeft}</span>
                        <span className={`font-bold text-[24px] inline-block leading-[24px]`}>
                            {t('gameui.secondsShort')}
                        </span>
                    </div>
                </div>
            </div>
        )
    )
}

export default FreespinsPressStartCounter
